module.exports = __webpack_public_path__ + "static/pie_painter_8-425687ebbb0e8107b02e5a19067806cd.png";